import { DataCard } from '../../../components/DashboardCard';
import { useScheduledAds } from '../../../hooks/Dashboard/useScheduledAds';

export const ScheduledAdsCard = (props: DashboardCardProps) => {
  const { theme } = props;
  const { scheduledAds, getScheduledAds, loading } = useScheduledAds();

  return (
    <DataCard
      data={scheduledAds}
      title="Scheduled Ads"
      views={['list']}
      columns={[
        { name: 'Ad Name', dataKey: 'name' },
        { name: 'Location', dataKey: 'location' },
        { name: 'Time', dataKey: 'startDate' },
      ]}
      loading={loading}
      refresh
      onRefresh={getScheduledAds}
      enableTimespan
      theme={theme}
    />
  );
};
